
// document.addEventListener("DOMContentLoaded", function () {
// Thumbnails slider
var secondarySlider = new Splide('#secondary-slider', {

  rewind       : false,
   arrows      : false,
//   fixedWidth   : 100,
//   fixedHeight  : 64,
  isNavigation : true,
  gap          : 10,
  pagination   : false,
  cover        : true,
//autoplay    :      true,
  drag         : true,
  // breakpoints  : {
  //   600: {
  //     fixedWidth  : 66,
  //     fixedHeight : 40,
  //   }
  // }
}).mount();


// Main slider
var primarySlider = new Splide('#primary-slider', {
 type: 'loop',
 start: 0,
    perPage: 1,
    arrows: false,
    autoplay: true,
    cover: true,
     heightRatio: 0.5,
     clones: 3,     
     flickMaxPages: 1,
    //cloneStatus: false,
     interval: 6000,        
     speed: 1200, 
     easing: 'ease-in-out',
    flickMaxPages: 1,
    // updateOnMove: true,
    pagination: false,
    padding: 0,
    rewind: false,
     pauseOnHover: false,
  pauseOnFocus: false,
  pauseOnInteraction: false,
      breakpoints: {
           1435: {
                heightRatio: 0.6,
             
            },
             1220: {
                heightRatio: 0.7,
             
            },
             992: {
               heightRatio: 0.8,
             
            },
             920: {
               heightRatio: 0.9,
             
            },
            749: {
               heightRatio: false,
             
            },
          },
});

primarySlider.on('mounted', () => {
  primarySlider.refresh();
});



// Sync sliders
primarySlider.sync(secondarySlider).mount();

// });

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const sticky_header_background = document.querySelector(".header-wrapper");
  const slideshow = document.querySelector(".slideshow-section-target");
  const announcement = document.querySelector(".announcement-bar-section");  

  if (!header || !slideshow || !announcement) return;

  const headerHeight = header.offsetHeight;
  const slideshowTop = slideshow.offsetTop;
  const slideshowHeight = slideshow.offsetHeight;
  const parallaxSpeed = 0.3; // Adjust for intensity

  let ticking = false;

  function update() {
    const scrollY = window.scrollY;
    
    // 1. PARALLAX CALCULATION
    if (scrollY + window.innerHeight > slideshowTop && scrollY < slideshowTop + slideshowHeight) {
      const relativeScroll = scrollY - slideshowTop;
      const yPos = relativeScroll * parallaxSpeed;
      
      // Move the slideshow down slightly as we scroll to create depth
      slideshow.style.transform = `translate3d(0, ${yPos}px, 0)`;
      slideshow.style.zIndex = "1"; // Keep it at the bottom layer
    }

    // 2. ANNOUNCEMENT STICKY LOGIC
    const slideshowStickyEnd = slideshowTop + slideshowHeight - headerHeight;

    if (scrollY >= slideshowStickyEnd) {
      announcement.style.position = "fixed";
      announcement.style.top = headerHeight + "px";
      announcement.style.zIndex = "10"; // Keep it above the slideshow
      announcement.classList.add("is-sticky");
    } else {
      announcement.style.position = "";
      announcement.style.top = "";
      announcement.style.zIndex = "";
      announcement.classList.remove("is-sticky");
    }

    if (announcement.classList.contains('is-sticky')) {
        sticky_header_background.classList.add('background_color');
    } else {
        sticky_header_background.classList.remove('background_color');
    }    

    ticking = false;
  }

  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  });

});